import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import PropTypes from 'prop-types';
import { useMutation } from 'urql';
import css from './Question.module.scss';
import dateString from '../../../utils/dates/toString';
import OV from '../../../components/icons/OV';
import parseISOLocal from '../../../utils/dates/parseISOLocal';
import QUESTION_VOTE_MUTATION from './queries';
import UpvoteDownvote from '../../../components/UpvoteDownvote';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Question = function Question(_ref) {
  var body = _ref.body,
      createdAt = _ref.createdAt,
      downvotes = _ref.downvotes,
      id = _ref.id,
      name = _ref.name,
      response = _ref.response,
      upvotes = _ref.upvotes;

  var _useMutation = useMutation(QUESTION_VOTE_MUTATION),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      res = _useMutation2[0],
      executeMutation = _useMutation2[1]; // eslint-disable-line


  var executeVote = function executeVote(_ref2) {
    var questionId = _ref2.id,
        score = _ref2.score;
    executeMutation({
      questionId: questionId,
      score: score
    });
  };

  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsxs("header", {
      className: css.header,
      children: [/*#__PURE__*/_jsx("h5", {
        className: css.author,
        children: name.split(' ')[0]
      }), /*#__PURE__*/_jsx("span", {
        className: css.createdAt,
        children: dateString(parseISOLocal(createdAt))
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: css.main,
      children: [/*#__PURE__*/_jsxs("p", {
        className: css.question,
        children: ["Q:\xA0", body]
      }), response.length > 0 && /*#__PURE__*/_jsxs("div", {
        className: css.reply,
        children: [/*#__PURE__*/_jsxs("div", {
          className: css.answerContainer,
          children: [/*#__PURE__*/_jsx("span", {
            className: css.label,
            children: "Response from Team OV"
          }), /*#__PURE__*/_jsxs("div", {
            className: css.answer,
            children: [/*#__PURE__*/_jsx(OV, {
              className: css.ovLogo
            }), /*#__PURE__*/_jsx("div", {
              className: css.response,
              dangerouslySetInnerHTML: {
                __html: response
              }
            })]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: css.votes,
          children: [/*#__PURE__*/_jsx("span", {
            className: css.label,
            children: "Was this answer helpful?\xA0"
          }), /*#__PURE__*/_jsx(UpvoteDownvote, {
            id: id,
            downvotes: downvotes,
            executeVote: executeVote,
            storageKey: "question_voted_".concat(id),
            upvotes: upvotes
          })]
        })]
      })]
    })]
  });
};

Question.defaultProps = {
  downvotes: 0,
  response: '',
  upvotes: 0
};
Question.propTypes = {
  body: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  downvotes: PropTypes.number,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  response: PropTypes.string,
  upvotes: PropTypes.number
};
export default Question;